import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Typography } from 'antd'
import { HomeOutlined, MailOutlined, RocketOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import colozooLogo from '../assets/colozoo_logo.svg'
import { COLOZOO_SLOGAN } from '../constants/brand'
import PageTitle from './PageTitle'
import PageLayout from './PageLayout'
import PageControls from './PageControls'
import SiteFooter from './SiteFooter'
import { updateMetaTags } from '../utils/metaTagManager'
import './NotExist.css'

const SUPPORT_EMAIL = 'support@colozoo.de'

const NotExist = () => {
  const { t, i18n } = useTranslation('notFound')
  const navigate = useNavigate()
  const txt = (key: string) => String(t(key))

  useEffect(() => {
    updateMetaTags({
      title: txt('meta.title'),
      description: txt('meta.description'),
      url: window.location.href,
    })
  }, [i18n.language, t])

  const mailto = `mailto:${SUPPORT_EMAIL}`

  return (
    <>
      <PageTitle title={txt('meta.title') || 'Coming soon – Colozoo'} />
      <PageLayout>
        <div className="not-found-page">
          <div className="not-found-controls">
            <PageControls showUserProfile={false} />
          </div>
          <div className="not-found-main">
            <div className="not-found-panel">
              <img src={colozooLogo} alt="Colozoo" className="not-found-logo" />
              <p className="not-found-slogan">{COLOZOO_SLOGAN}</p>

              <div className="not-found-icon" aria-hidden="true">
                <RocketOutlined />
              </div>

              <Typography.Title level={2} className="not-found-heading">
                {txt('titleLead')}{' '}
                <span className="not-found-heading-accent">{txt('titleAccent')}</span>
              </Typography.Title>

              <Typography.Paragraph className="not-found-body">{txt('body1')}</Typography.Paragraph>
              <Typography.Paragraph className="not-found-body not-found-body--last">{txt('body2')}</Typography.Paragraph>

              <div className="not-found-actions">
                <Button
                  type="primary"
                  size="large"
                  icon={<HomeOutlined />}
                  onClick={() => navigate('/')}
                  className="not-found-btn-home"
                >
                  {txt('goHome')}
                </Button>
                <Button
                  size="large"
                  icon={<MailOutlined />}
                  href={mailto}
                  className="not-found-btn-ask"
                >
                  {txt('askQuestion')}
                </Button>
              </div>

              <p className="not-found-contact">
                {txt('contactLabel')}{' '}
                <a href={mailto}>{txt('contactLink')}</a>
              </p>
            </div>
          </div>
          <SiteFooter />
        </div>
      </PageLayout>
    </>
  )
}

export default NotExist
